module.exports = {"vp":["PKW","LKW","Busse","Finanzdienstleistungen"],"ka":["Produktion","Design"],"kp":["Zulieferer"],"cr":["Hauptsächlich Premium-Marken"],"cs":["Massenmarkt"],"ch":["Autohändler","Vertriebsmitarbeiter"],"kr":["Produktionsstätten","Geistiges Eigentum","Marken"],"cS":["Marketing und Vertrieb","Produktion","Forschung und Entwicklung"],"rS":["Autoverkauf","Autofinanzierung"],"description":""}


//////////////////
// WEBPACK FOOTER
// ./static/Daimler.json
// module id = ycpy
// module chunks = 1